<template>
  <div>
    <el-page-header @back="goBack" content="测评结果设置"></el-page-header>
    <div class="topic-outer">
      <div class="appraisal-center fonts">
        <div class="pub-line">
          <span>分类：</span>
          <span class="glay"
          >{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
          >
        </div>
        <div class="flex-box pub-line">
          <div class="fl1">
            <span>名称：</span>
            <span class="glay">{{ detalisObj.name }}</span>
          </div>
          <div class="fl1">
            <span> 标识：</span>
            <span class="glay">{{ detalisObj.examId }}</span>
          </div>
        </div>

        <div class="flex-box pub-line">
          <div class="fl1">
            <span>解析：</span>
            <span class="glay">{{ detalisObj.schemeName }}</span>
          </div>
          <div class="fl1">
            <span> 题目：</span>
            <span class="glay"
            >共 <i>{{ detalisObj.questions }}</i
            >题，<i>{{ detalisObj.maxScore }}</i
            >分</span
            >
          </div>
        </div>
        <div style="margin-top: 30px">
          <el-button type="primary" @click="handelResultSet" plain
          >基本结果设置
          </el-button
          >
          <el-button @click="goTopic" type="danger" plain
          >返回题目
          </el-button
          >
        </div>
      </div>
    </div>
    <div class="topic-outer" style="padding-top:20px">
      <el-tabs v-model="activeNames" @tab-click="handleTabClick">
        <el-tab-pane label="暗黑指数设置" name="first"></el-tab-pane>
        <el-tab-pane label="人格结果设置" name="second"></el-tab-pane>
      </el-tabs>
      <div v-if="activeNames=='first'">
        <div style="margin-left: 20px">
          <div class="public-dialog-form">
            <div class="item_info_tabs">暗黑指数设置</div>
            <div v-for="(item,index) in qjList" :key="index" style="margin-bottom: 20px">
              <div class="item_contents">
                <div>
                  <div class="input_item">
                    <div class="name">分数区间：</div>
                    <div>
                      <el-input style="width: 260px" v-model="item.minScore" type="number"
                                placeholder="请输入最小分值（大于等于）"></el-input>
                      -
                      <el-input v-model="item.maxScore" style="width: 260px" type="number"
                                placeholder="请输入最大分值（小于等于）"></el-input>
                    </div>
                  </div>
                  <div class="input_item">
                    <div class="name">区间名称：</div>
                    <div>
                      <el-input v-model="item.title" style="width: 260px" placeholder="请输入名称"></el-input>
                    </div>
                  </div>
                  <div class="input_item">
                    <div class="name">区间解析：</div>
                    <el-input
                        style="width: 420px"
                        type="textarea"
                        :autosize="{ minRows: 3, maxRows: 4 }"
                        placeholder="请填写区间解析"
                        v-model="item.descr"
                    >
                    </el-input>
                  </div>
                </div>
                <div v-if="qjList.length>1" @click="removeQj(index,item)" class="remove_icon"><i
                    class="el-icon-delete"
                    style="color: #c7302f;font-size: 18px"></i>
                </div>
              </div>
              <div>
                <el-button @click="handQjEdit(index,item)" type="primary">保存设置</el-button>
              </div>
            </div>
          </div>
          <div>
            <el-button type="primary" @click="addQj">添加分数区间</el-button>
          </div>
        </div>
      </div>
      <!--      -->
      <div v-if="activeNames=='second'  ">
        <div class="second_tops" v-loading="loading" >
          <div style="min-height: 60vh" v-if="!noContent">
            <template v-if="initJZData && initJZData.length">
              <el-tabs
                  tab-position="left"
                  v-model="activeNameT"
                  @tab-click="handTabLimt"
              >
                <el-tab-pane
                    v-for="item in initJZData"
                    :key="item.examResultId"
                    :label="item.name"
                    :name="item.examResultId.toString()"
                >
                </el-tab-pane>
                <div style="margin-left: 20px">
                  <div class="public-dialog-form">
                    <el-form
                        ref="ruleForm"
                        :rules="rules"
                        :model="params"
                        label-width="85px"
                    >
                      <el-row type="flex">
                        <el-col :span="14">
                          <el-form-item label="人格特征" prop="title">
                            <el-input v-model="params.title" style="width: 300px" placeholder="请输入名称"></el-input>
                          </el-form-item>
                          <el-form-item label="代表人物" prop="suggest2">
                            <el-input v-model="params.suggest2" style="width: 300px" placeholder="请输入名称"></el-input>
                          </el-form-item>
                          <el-form-item label="人物语录" prop="content">
                            <el-input
                                style="width: 300px"
                                type="textarea"
                                :autosize="{ minRows: 3, maxRows: 4 }"
                                placeholder="请填写主题"
                                v-model="params.content"
                            >
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="6">
                          <el-form-item label="人物肖像">
                            <div class="diplay" style="margin-right: 10px">
                              <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in srcList"
                    :key="index"
                    class="slideshow"
                >
                  <el-image
                      style="width: 135px; height: 135px;border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPolicy"
                  />
                </span>
                                <div
                                    class="up-btn"
                                    style="width: 135px; height: 135px; line-height: 135px"
                                    @click="getPolicy"
                                    v-if="isMoer"
                                >
                                  <i class="el-icon-plus"></i>
                                </div>
                              </div>
                              <input
                                  type="file"
                                  ref="file"
                                  @change="getFile"
                                  accept="image/png,image/jpg"
                              />
                            </div>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-form-item label="性格描述" prop="content">
                        <rich-text v-if="innerVisible" :keyWord="'descr'" :params="params?params:''"></rich-text>
                      </el-form-item>
                      <el-form-item label="人际模式" prop="content">
                        <rich-text v-if="innerVisible" :keyWord="'suggest'" :params="params?params:''"></rich-text>
                      </el-form-item>
                      <el-form-item label="行为风格" prop="content">
                        <rich-text v-if="innerVisible" :keyWord="'guideSuggest'" :params="params?params:''"></rich-text>
                      </el-form-item>
                    </el-form>
                    <span slot="footer" class="public-dialog-footer">
                      <el-button size="medium" @click="handleEdit('reset')"
                      >重 置</el-button
                      >
                      <el-button
                          size="medium"
                          type="primary"
                          @click="handleEdit('add')"
                      >提 交</el-button
                      >
                    </span>
                  </div>
                </div>
              </el-tabs>
            </template>
          </div>
        </div>
        <div v-if="noContent">
          <el-empty description="描述文字"></el-empty>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {ossUpload} from "@utils/filters/upload";
import richText from "../../../components/richText";

export default {
  components: {
    richText,
  },
  data() {
    return {
      rules: {
        title: [
          {
            required: true,
            message: "请填写标题",
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: "请填写入内容",
            trigger: "blur",
          },
        ],
      },
      detalisObj: {},
      loading: false,
      jzIsShow: true,
      jzIsHiden: false,
      initJZData: [],
      activeName: "",
      params: {},
      activeNames: 'first',
      activeNameT: '',
      getWDData: [],
      qjList: [
        {
          minScore: 0,
          maxScore: 0,
          title: '',
          descr: ''
        }
      ],
      srcList: [],
      isMoer: true,
      innerVisible: false,
      noContent:false
    };
  },
  created() {
    this.getAppraisalData();
    this.getWDList();
    // this.initJZ()
  },
  methods: {
    getPolicy() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    async getFile() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.file.files[0],
          resData.data,
          "one", //'more','one'
          this.srcList
      );
      this.isMoer = false;
      this.srcList = addRoutes;
      this.params.icon = this.srcList[0];
    },
    /**
     * 跳转结果设置
     */
    handelResultSet() {
      this.$router.push({
        name: "ANRG_SET",
        query: {
          examId: this.$route.query.examId,
        },
      });
    },
    handQjEdit(index, item) {
      if (!item.minScore) {
        this.$message.error('最小分数不能为空')
        return
      }
      if (!item.maxScore) {
        this.$message.error('最大分数不能为空')
        return
      }
      if (!item.title) {
        this.$message.error('名称不能为空')
        return
      }
      this.$confirm("确认保存数据, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {
        if (item.examResultId) {
          let obj = {
            resultType: 'ahrg',
            examId: this.$route.query.examId,
            examDimensionCode: this.activeName,
            minScore: item.minScore,
            maxScore: item.maxScore,
            title: item.title,
            descr: item.descr,
            examResultId: item.examResultId
          }
          const {data: resData} = await this.$put(
              "exam/result/info",
              obj,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.$message.success("提交成功!");
        } else {
          let obj = {
            resultType: 'ahrg',
            examId: this.$route.query.examId,
            examDimensionCode: this.activeName,
            minScore: item.minScore,
            maxScore: item.maxScore,
            title: item.title,
            descr: item.descr,
          }
          const {data: resData} = await this.$post(
              "exam/result/info",
              obj,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.$message.success("提交成功!");
        }
      })
    },
    async getWDList() {
      this.getWDData = [];
      this.loading = true;
      const {data: resData} = await this.$get(`exam/dimension/list`, {
        params: {
          examId: this.$route.query.examId,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data)
        if (resData.data) {
          this.getWDData = resData.data;
          this.activeName = resData.data[0].code
          this.initQjJZ()
        } else {
          this.getWDData = []
        }
    },

    handleTabClick() {
      if (this.activeNames == 'first') {
        this.getWDList();
      } else {
        this.initJZ()
      }
    },
    removeQj(e, item) {
      if (item.examResultId) {
        this.$confirm("确认删除数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          const {data: resData} = await this.$delete(
              "exam/result/info/" + item.examResultId,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.$message.success("提交成功!");
          this.qjList.splice(e, 1)
        })
      } else {
        this.qjList.splice(e, 1)
      }
    },

    addQj() {
      let obj = {
        minScore: 0,
        maxScore: 0,
        title: '',
        descr: ''
      }
      this.qjList.push(obj)
    },
    /**
     * 获取测评详情
     */
    async getAppraisalData() {
      this.loading = true;
      const {data: resData} = await this.$get(
          `exam/info/${this.$route.query.examId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.detalisObj = resData.data;
    },
    /**
     * 初始化基准
     */
    async initJZ() {
      this.loading = true;
      const {data: resData} = await this.$post(
          `exam/result/init/datum/${this.$route.query.examId}`
      );

      if (resData.result != 200) {
        this.loading = false;
        return;
      }
      if (resData.data) {
        this.loading = false;
        this.jzIsShow = false;
        this.jzIsHiden = true;
        resData.data.map(item => {
          item.examResultContent = item.name + '\n' + item.code
        })
        this.initJZData = resData.data;
        let id = resData.data[0].examResultId;
        this.activeNameT = id.toString();
        this.params.examResultId = id;
        this.resultDetails(id);
      } else {
        this.initJZData = []
        this.loading = false;
        this.noContent = true
      }

    },

    handleEdit(type) {
      if (type == "add") {
        this.$refs.ruleForm.validate((valid) => {
          if (!valid) return;
          this.$confirm("确认保存数据, 是否继续?", "提示", {
            type: "info",
          }).then(async () => {
            const {data: resData} = await this.$put(
                "exam/result/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.$message.success("提交成功!");
          })
        });
      } else if (type == "reset") {
        this.$confirm("确认重置当前数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          const {data: resData} = await this.$post(
              "exam/result/init/datum/" + this.$route.query.examId,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          this.$refs.ruleForm.resetFields();
          this.params = {}
          this.$message.success("重置成功!");
        })
      }
    },
    async initQjJZ() {
      this.loading = true;
      const {data: resData} = await this.$get(
          '/exam/result/list?examId=' + this.$route.query.examId + '&examDimensionCode=' + this.activeName + '&resultType=ahrg'
      );
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        this.qjList = resData.data
      } else {
        this.qjList = [
          {
            minScore: 0,
            maxScore: 0,
            title: '',
            descr: ''
          }
        ]
      }
    },

    async resultDetails(examResultId) {
      const {data: resData} = await this.$get(
          `exam/result/info/${examResultId}`,
          {
            headers: {
              isLoading: true,
            },
          }
      );
      this.srcList = []
      this.isMoer = true
      if (resData.result != 200) return;
      this.params = resData.data;
      if (resData.data.icon) {
        this.srcList.push(resData.data.icon)
        this.isMoer = false
      }
      this.innerVisible = true
    },

    handleClick() {
      this.initQjJZ()
    },

    handTabLimt(tab, event) {
      this.innerVisible = false
      this.$refs.ruleForm.resetFields();
      this.params.examResultId = parseInt(tab.name);
      this.resultDetails(tab.name);
    },
    goBack() {
      this.$router.go(-1);
    },
    goTopic(){
      this.$router.push({
        name: "AHRG_LIST",
        query: {
          examId: this.$route.query.examId,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.editor {
  line-height: normal !important;
  margin-bottom: 30px;
}

.initialize {
  margin-top: 20px;
}

.appraisal-title {
  color: #3a3a3a;
}

.appraisal-center {
  width: 90%;
  margin: 0 auto;
}

.fonts {
  font-size: 14px;
}

.topic-outer {
  width: 100%;
  background: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 30px;
}

.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.fl1 {
  flex: 1;
  -webkit-flex: 1;
}

.glay {
  color: #8492a6;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.pub-line {
  margin-top: 30px;
}

.pub-marr {
  margin-top: 20px;
}

.marr {
  margin-top: 30px;
}

.tag-marr {
  margin-right: 5px;
  cursor: pointer;
}

.subject {
  color: #8492a6;
  margin-left: 10px;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.activeBg {
  background: #b3d8ff;
  color: #fff;
}

.active-bg1 {
  background: #fbc4c4;
  color: #fff;
}

.item_contents {
  display: flex;

  .remove_icon {
    margin-left: 10px;
  }
}

.input_item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 14px;

  .name {
    margin-right: 5px;
  }
}

.item_info_tabs {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}


</style>
<style>
.second_tops .el-tabs__item {
  white-space: pre-wrap;
  text-align: left !important;
  line-height: 20px;
  width: 300px;
  height: 46px !important;
}
</style>